import { render, staticRenderFns } from "./promoterInfo.vue?vue&type=template&id=123df07f&scoped=true&"
import script from "./promoterInfo.vue?vue&type=script&lang=js&"
export * from "./promoterInfo.vue?vue&type=script&lang=js&"
import style0 from "./promoterInfo.vue?vue&type=style&index=0&id=123df07f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123df07f",
  null
  
)

export default component.exports